import { useQuery } from 'react-query';

import { BaseModel, PackagingConfig } from './api/types';
import { fetchPackageTypes, fetchPackagingConfig } from './api/package';

export const usePackagingTypes = () => {
    return useQuery<BaseModel[], Error>(['packagingTypes'], async () => await fetchPackageTypes());
};

export const usePackageCategories = () => {
    return useQuery<BaseModel[], Error>(['packageCategories'], async () => await fetchPackageTypes());
};

export const usePackageModels = () => {
    return useQuery<BaseModel[], Error>(['packageModels'], async () => await fetchPackageTypes());
};

export const usePackages = () => {
    return useQuery<BaseModel[], Error>(['packages'], async () => await fetchPackageTypes());
};

export const usePackagingConfig = (organizationId?: string) => {
    return useQuery<PackagingConfig, Error>(['packagingConfig', organizationId], async () => {
        const config = await fetchPackagingConfig();
        if (organizationId) {
            return {
                ...config,
                packages: config.packages.filter(
                    (pkg) =>
                        Array.isArray(pkg.organization) && pkg.organization.some((org) => org.id === organizationId)
                ),
            };
        }
        return config;
    });
};
